import React from 'react'

import { LntButton, LntDrawer, LntForm, LntFormItem, LntSelect } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'
import { CATALOG_KEY } from '@app/constants/queryKeys'
import { SEPARATOR } from '@app/constants/separator'

import { getFilterFromEntities, getFilterFromEntitiesToLabelsIds, getIdsFromEntity } from '@app/utils/entitiesAdapters'

import {
  getCategories,
  getCommodityGroups,
  getPurchasingGroups,
  getSubcategories,
  getTrends
} from '@app/api/routes/catalog'

import styles from './styles.module.scss'

import type { LntSelectProps } from '@app/components/base/Select/types'
import type { RecommendationsDrawerProps } from './types'
import type { TaskTotalRunParametersData } from '@app/api/routes/monitoringTasks/types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  tokenSeparators: [SEPARATOR.newline]
}

export const RecommendationsDrawer: React.FC<RecommendationsDrawerProps> = props => {
  const { recommendation, isLoading, onClose, onSubmit, ...restProps } = props

  const handleSubmit = (data: TaskTotalRunParametersData): void => {
    onSubmit(data)
  }

  return (
    <LntDrawer
      { ...restProps }
      title='Рекомендации по направлению'
      onClose={ onClose }
      width={ 400 }
    >
      <LntForm
        layout='vertical'
        onSubmit={ handleSubmit }
      >
        <div className={ styles.recommendationsDrawer__itemsWrapper }>
          <LntFormItem
            name='trendIds'
            defaultValue={ getIdsFromEntity(recommendation?.trends) }
          >
            <LntSelect
              { ...commonSelectProps }
              placeholder={ FILTERS_PLACEHOLDERS.trendsFilter }
              querySelect={ {
                queryKey: [CATALOG_KEY.trendsItems],
                queryFn: getTrends,
                select: getFilterFromEntities
              } }
            />
          </LntFormItem>

          <LntFormItem
            name='purchasingGroupIds'
            defaultValue={ getIdsFromEntity(recommendation?.purchasingGroups) }
          >
            <LntSelect
              { ...commonSelectProps }
              placeholder={ FILTERS_PLACEHOLDERS.purchasingGroupsFilter }
              querySelect={ {
                queryKey: [CATALOG_KEY.purchasingGroupsItems],
                queryFn: getPurchasingGroups,
                select: getFilterFromEntitiesToLabelsIds
              } }
            />
          </LntFormItem>

          <LntFormItem
            name='commodityGroupIds'
            defaultValue={ getIdsFromEntity(recommendation?.commodityGroups) }
          >
            <LntSelect
              { ...commonSelectProps }
              placeholder={ FILTERS_PLACEHOLDERS.commodityGroupsFilter }
              querySelect={ {
                queryKey: [CATALOG_KEY.commodityGroupsItems],
                queryFn: getCommodityGroups,
                select: getFilterFromEntities
              } }
            />
          </LntFormItem>

          <LntFormItem
            name='categoryIds'
            defaultValue={ getIdsFromEntity(recommendation?.categories) }
          >
            <LntSelect
              { ...commonSelectProps }
              placeholder={ FILTERS_PLACEHOLDERS.categoriesFilter }
              querySelect={ {
                queryKey: [CATALOG_KEY.categoriesItems],
                queryFn: getCategories,
                select: getFilterFromEntitiesToLabelsIds
              } }
            />
          </LntFormItem>

          <LntFormItem
            name='subcategoryIds'
            defaultValue={ getIdsFromEntity(recommendation?.subcategories) }
          >
            <LntSelect
              { ...commonSelectProps }
              placeholder={ FILTERS_PLACEHOLDERS.subcategoriesFilter }
              querySelect={ {
                queryKey: [CATALOG_KEY.subcategoriesItems],
                queryFn: getSubcategories,
                select: getFilterFromEntitiesToLabelsIds
              } }
            />
          </LntFormItem>

          <div className={ styles.recommendationsDrawer__buttons }>
            <LntButton
              type={ BUTTON_TYPE.primary }
              htmlType='submit'
              loading={ isLoading }
            >
              Сохранить
            </LntButton>
          </div>
        </div>
      </LntForm>
    </LntDrawer>
  )
}
